import { userManager } from './userManger';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';
import { getAccessToken } from '../../libs/security/utils';

export const getToken = async () => {
  let token = null;
  await userManager
    .getUser()
    .then((user) => getAccessToken(user))
    .then((tk) => {
      tk ? (token = tk) : Logger.warn(['token empty', tk], LogArea.Security);
    })
    .catch(() =>
      userManager.signinRedirect({
        state: window.location.pathname + window.location.search,
      })
    );
  return token;
};
export const printToken = () =>
  getToken().then((token) =>
    Logger.info(['Security::Token', token], LogArea.Security)
  );
